module.exports = __webpack_public_path__ + "static/media/teamitem14.12d0b74a.png";